__webpack_require__.p = "/frontend-for-bot/";